import { getSchema, MergeField, MergeSchema } from '../../decorators';
import { ActivityEntityName } from '../../../../entities';
import { ActivityMergeData } from './activity.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Invoice,
    name: "InvoiceItemMergeDataSchema"
})
export class InvoiceItemMergeData {

    @MergeField()
    name: string;

    @MergeField()
    description: string;

    @MergeField()
    codeUoM: string;

    @MergeField()
    quantity: number;

    @MergeField()
    price: string;

    @MergeField()
    subTotal: string;

    @MergeField()
    tax: string;

    @MergeField()
    total: string;

    @MergeField()
    location: string;

    @MergeField()
    notes: string;

    @MergeField()
    status: string;

    @MergeField()
    invoicingStatus: string;

    sortOrder: number;
}

export const InvoiceItemMergeDataSchema = getSchema(InvoiceItemMergeData);

@MergeSchema({
    entity: ActivityEntityName.Invoice
})
export class InvoiceMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    invoiceNumber: string;

    @MergeField()
    status: string;

    @MergeField()
    invoiceDate: string;

    @MergeField()
    dueDate: string;

    @MergeField()
    generatedDate?: string;

    @MergeField()
    lastIssuedDate?: string;

    @MergeField()
    lastPaymentDate?: string;

    @MergeField()
    customerReference: string;

    @MergeField()
    notes: string;

    @MergeField()
    taxInclusiveOption: string;

    @MergeField()
    taxRate: string;

    @MergeField()
    terms: string;

    @MergeField()
    timezone?: string;

    // @MergeField()
    // source?: string;

    @MergeField()
    createdBy: string;

    @MergeField()
    createdAt?: string;

    @MergeField()
    updatedAt?: string;

    @MergeField()
    updatedBy?: string;

    @MergeField()
    version?: string;

    @MergeField()
    subTotal?: string;

    @MergeField()
    tax?: string;

    @MergeField()
    total?: string;

    @MergeField()
    amountPaid?: string;

    @MergeField()
    creditAmount?: string;

    @MergeField()
    roundingAmount?: string;

    @MergeField()
    outstandingAmount?: string;

    @MergeField()
    jobNumber: string;

    @MergeField()
    workOrderNumber: string;

    @MergeField({ arraySchemaName: "InvoiceItemMergeDataSchema" })
    lines: InvoiceItemMergeData[]

    @MergeField({ arraySchemaName: "InvoiceItemMergeDataSchema" })
    invoiceLinesExcludeZero: InvoiceItemMergeData[];

    @MergeField({ arraySchemaName: "InvoiceItemMergeDataSchema" })
    invoiceLinesExZeroByLoc: InvoiceItemMergeData[];

    @MergeField({
        arraySchemaName: "InvoiceItemMergeDataSchema",
        includeFields: ["name", "description", "quantity", "price", "location", "notes"]
    })
    jobLinesBillable: InvoiceItemMergeData[];

    linesNotZero: InvoiceItemMergeData[];

    prepaymentSubTotal: number;
    prepaymentTotal: number;
    prepaymentTax: number;
}

export const InvoiceMergeSchema = getSchema(InvoiceMergeData);